import { render, staticRenderFns } from "./CenterAccount.vue?vue&type=template&id=68a7730a&"
import script from "./CenterAccount.vue?vue&type=script&lang=js&"
export * from "./CenterAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports